export default __webpack_public_path__ + "logo-04f40e29.png";